/**
 * ✅ Phone utilities for formatting, normalizing, and validation
 */
export class PhoneUtils {
  /**
   * Normalize input to US phone number (digits only)
   * Removes spaces, dashes, parentheses, etc.
   */
  static normalize(phone: string): string {
    if (!phone) return '';
    return phone.replace(/\D/g, '');
  }

  /**
   * Format phone number with +1 prefix (E.164 style)
   * Example: (123) 456-7890 => +11234567890
   */
  static toE164(phone: string): string {
    const digits = this.normalize(phone);

    if (digits.length === 11 && digits.startsWith('1')) {
      return '+' + digits;
    }

    if (digits.length === 10) {
      return '+1' + digits;
    }

    return phone; // fallback (invalid length)
  }

  /**
   * Format phone number to user-friendly style
   * Example: 1234567890 => (123) 456-7890
   */
  static toDisplayFormat(phone: string): string {
    const digits = this.normalize(phone);
    if (digits.length !== 10) return phone;

    return `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
  }
}
